<template>
  <ReportNextEvents mode="all" />
</template>

<script>
export default {
  mounted() {
    this.pageLink=this.stores.page.stack[
      this.stores.page.pushPage("Pregled", this.$route.params.path)];
  },
  unmounted() {
    this.stores.page.popPage(this.pageLink);
  },

}
</script>
